<md-dialog>
	<div md-dialog-header class="header">
		<md-icon icon="untitled-ui/time/clock-refresh"></md-icon>
		<div>
			<div class="md-text-lg-semibold">Select a new lesson time</div>
			<div class="md-text-sm-regular">
				for the {{ lesson()?.lessonDate | tzDate: 'MMMM d' }} ({{ lesson()?.lessonDate | tzTime }} - {{ lesson()?.lessonEndDate | tzTime }})
			</div>
		</div>
	</div>

	@if (rescheduling()) {
		<lb-loader message="Rescheduling your lesson"></lb-loader>
	} @else if (loading()) {
		<lb-loader message="Loading available times"></lb-loader>
	} @else if (hasNoOptions()) {
		<div class="no-options">
			<md-icon icon="untitled-ui/general/calendar-x"></md-icon>
			<div class="md-text-md-semibold">No times available</div>
			<div class="md-text-sm-regular">Your instructor has no available makeup times right now. Please contact them to arrange a new time.</div>
		</div>
	} @else {
		<div class="options-body">
			@if (slotsByDate().length > 0) {
				<div class="quick-selects">
					<div class="quick-selects-label md-text-sm-semibold">Next available</div>
					<div class="quick-selects-chips">
						@for (slot of quickSlots(); track slot.date) {
							<button md-button [class.active]="isSlotSelected(slot)" (click)="selectQuickSlot(slot)">
								{{ slot.date | tzDate: 'MMMM d' }} at {{ slot.date | tzTime: 'h:mm a' }}
							</button>
						}
					</div>
				</div>

				<div class="slots-section">
					<div class="slots-section-title md-text-sm-semibold">Available times</div>
					<div class="calendar-slots">
						<div class="calendar-left">
							<md-date-picker
								[selectedDates]="selectedCalendarDate() ? [selectedCalendarDate()!] : []"
								[disabledDateFn]="disableCalendarDay()"
								(change)="updateCalendarDate($event[0])"
							>
							</md-date-picker>
						</div>
						<div class="calendar-right">
							@if (selectedCalendarDate()) {
								<div class="calendar-right-date md-text-sm-semibold">{{ selectedCalendarDateLabel() }}</div>
							}
							<div class="slot-chips">
								@for (slot of slotsForSelectedDate(); track slot.date) {
									<button md-button [class.active]="isSlotSelected(slot)" (click)="selectSlot(slot)">
										{{ slot.date | tzTime: 'h:mm a' }}
									</button>
								} @empty {
									<div class="no-slots md-text-sm-regular">No available times on this day</div>
								}
							</div>
						</div>
					</div>
				</div>
			} @else {
				<div class="no-flex-times">
					<md-icon icon="untitled-ui/general/calendar-minus"></md-icon>
					<div class="md-text-sm-regular">No additional times are available right now.</div>
				</div>
			}

			@if (afterLastSessionSlot(); as slot) {
				<div class="after-last-section">
					<div class="after-last-label md-text-sm-semibold">After last scheduled lesson</div>
					<div class="after-last-chips">
						<button md-button [class.active]="useAfterLastSession()" (click)="selectAfterLastSession()">
							{{ slot.date | tzDate: "EEEE, MMMM d 'at' h:mm a" }}
						</button>
					</div>
				</div>
			}
		</div>
	}

	<div md-dialog-footer>
		<button md-button [disabled]="rescheduling()" (click)="close()">Cancel</button>
		<button md-button-brand [disabled]="!canSubmit()" (click)="reschedule()">Update</button>
	</div>
</md-dialog>
